export { hasNonNegativeNumber } from "./hasNonNegativeNumber";
export { hasPositiveNumber } from "./hasPositiveNumber";
export { hasValue } from "./hasValue";
